import Mixin from '../index.js'

export default {
  mixins: [Mixin],
}
